<template>
<el-table
  class="table-striped"
  :data="categories"
  :default-sort="{prop: 'createdAt', order: 'descending'}"
  @sort-change=""
  v-loading="loading"
  style="width: 100%"
>
  <el-table-column
    prop="name"
    label="Name"
  >
    <template slot-scope="scope">
    <a @click="handleEdit(scope.row._id)">
      {{ scope.row.name }}
    </a>
    </template>
  </el-table-column>
  <el-table-column
    prop="apiEdu"
    label="Consultar API Edu"
  >
    <template slot-scope="scope">
    {{scope.row.apiEdu ? 'Sim' : 'Não'}}
    </template>
  </el-table-column>

  <el-table-column
    :width="100"
    fixed="right"
    label="Ações"
  >
    <template slot-scope="props">
    <div>
      <actions-table-categories
        :categorie="props.row"
        :handleRemove="handleRemove"
      />
    </div>
    </template>
  </el-table-column>

</el-table>
</template>

<script>
import ActionsTableCategories from './ActionsTableCategories'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'table-categories',

  components: {
    ActionsTableCategories
  },

  computed: {
    ...mapGetters('categories', {
      categories: 'categories',
      loading: 'loading'
    })
  },

  methods: {
    ...mapActions('categories', {
      deleteCategorie: 'delete'
    }),
    handleEdit (id) {
      this.$router.push({
        name: 'categories.edit',
        params: { id }
      })
    },

    handleRemove (params) {
      const swal = require('sweetalert2')
      swal({
        title: 'Você tem certeza?',
        text: `Não será possível reverter essa ação!`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(res => {
        if (res) {
          this.deleteCategorie(params.id)
            .then(res => this.$emit('refresh'))
            .catch(er => console.log(er))
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ConfigurationsPages/Categories/TableCategories.vue